
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1.33066C10 1.46961 9.94273 1.59252 9.82818 1.6994L3.0756 8L9.82818 14.3006C9.94273 14.4075 10 14.5304 10 14.6693C10 14.8083 9.94273 14.9312 9.82818 15.0381L8.96907 15.8397C8.85452 15.9466 8.72279 16 8.57388 16C8.42497 16 8.29324 15.9466 8.17869 15.8397L0.171821 8.36874C0.0572738 8.26186 0 8.13894 0 8C0 7.86106 0.0572738 7.73814 0.171821 7.63126L8.17869 0.160321C8.29324 0.0534402 8.42497 0 8.57388 0C8.72279 0 8.85452 0.0534402 8.96907 0.160321L9.82818 0.961924C9.94273 1.0688 10 1.19172 10 1.33066Z","transform":"translate(0 13) rotate(-90)"}})])
          )
        }
      }
    